/**
 * WorklistCardItem — CARD level (Claude Design round 7). The shipped WorklistAppointmentCard, mounted
 * as-is, in a wrapper that carries the card language: no shadow (the one-card rule: shadows are for
 * overlays; the bridge drops the v2 shadow utilities in the Today template), the selected card has
 * a 2px brand-primary leading accent. Clicking SELECTS the appointment; it does not open the visit.
 * GAP (DS): the card has no `selected` prop or elevation of its own, and clamps the name to 2 lines.
 */
import { WorklistAppointmentCard, cn } from '@scripsteam/scrips-signal-ds';
import type { TodayItem } from './today-types';

export function WorklistCardItem({
  item,
  selected,
  onSelect,
}: {
  item: TodayItem;
  selected: boolean;
  onSelect: (id: string) => void;
}) {
  // `card` carries the appointment id for keying; it is not a DOM id.
  const { id: _id, ...card } = item.card;
  return (
    <div
      data-slot="today-card"
      data-selected={selected ? 'true' : undefined}
      className={cn('relative min-w-0 flex-none rounded-card transition-shadow', selected ? 'shadow-4' : 'shadow-2')}
    >
      {selected && (
        <span aria-hidden="true" className="absolute inset-y-0 left-0 z-1 w-0.5 rounded-l-card bg-brand-primary" />
      )}
      <WorklistAppointmentCard
        {...card}
        onClick={() => onSelect(item.id)}
        aria-current={selected ? 'true' : undefined}
      />
    </div>
  );
}
